import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select';
import Switch from 'react-switch';
import CustomColumn from '../../../../customControl/CustomColumn'
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import CommonFilter from '../../../../customControl/CommonFilter';
import CustomTable from '../../../../customControl/CustomTable';
import { formatDate, generatePDF, getDateCombination, isImageValidPng, onlyAlphabets } from '../../../commonClass/CommonValidation';
import { areArraysEqualIgnoreOrder, SelectDropDownCheckboxInputOption } from '../../../commonClass/CommonFunctions';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { ExportExcel } from '../../../commonClass/ExportExcel';
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../../ImageUpload/ImageCommon';

const ActivityTab = ({ useradd, useredit, userexport }) => {
    const dispatch = useDispatch();
    const [modalShow, setModalShow] = useState(false);
    const [editDisabled, setEditDisabled] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const [mode, setMode] = useState("Add");
    const [countryCity, setCountryCity] = useState({
        stateData: [],
        cityData: []
    });

    const [formValue, setFormValue] = useState({
        ActivityId: 0,
        CollectionId: 0,
        StateIds: [],
        LocationIds: [],
        CategoryIds: [],
        ActivityName: "",
        ImageName: "",
        ImagePath: "",
        IsActive: false,
        UserId: 0
    });

    const [deleteImage, setDeleteImage] = useState("");
    const [formErrors, setFormErrors] = useState(null);
    const [collectionList, setCollectionList] = useState([]);

    const categoryList = useMemo(() => {
        return collectionList?.find((obj) => obj.collectionId === formValue?.CollectionId)?.categoryList ?? [];
    }, [collectionList, formValue?.CollectionId])


    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');
    const [searchDisabled, setSearchDisable] = useState(false);

    const [ActivityNameList, setActivityNameList] = useState([]);
    const [filterList, setFilterList] = useState([]);

    //#region on change functions
    const handleOnChange = (name, value) => {
        setEditDisabled(false);
        setFormErrors(null);
        if (name === "CollectionId") {
            setFormValue((prev) => ({ ...prev, [name]: value, CategoryIds: [] }));
        }
        else if (name === "StateIds") {
            setFormValue((prev) => ({ ...prev, [name]: value, LocationIds: [] }));
        }
        else if (name === "LocationIds") {
            setFormValue((prev) => ({ ...prev, [name]: value }));
        }
        else {
            setFormValue((prev) => ({ ...prev, [name]: value }));
        }
    }

    const handleUploadImage = (e) => {
        setEditDisabled(false);
        let error = {}
        const file = e.target.files?.[0];
        const size = (file.size / 1024) / 1024;
        if (isImageValidPng(file?.name) && size <= 5) {
            const filename = getDateCombination(file?.name);
            setFormValue((prev) => ({
                ...prev,
                ImageName: filename,
                ImagePath: 'CMS/Activity/' + filename,
                Path: 'CMS/Activity/',
                File: file,
                needToUpload: true
            }))
            setFormErrors(null);
        }
        else {
            setFormValue((prev) => ({
                ...prev,
                ImageName: "",
                ImagePath: "",
                Path: "",
                File: null,
                needToUpload: false
            }))
            document.getElementById("UploadImage").value = "";
            setFormErrors({ ...error, ImageName: !isImageValidPng(file.name) ? 'Only PNG file type is accepted.' : 'Cannot upload file that exceeds 5 MB.' })
            return;
        }
    }

    const handleisActive = (e) => {
        if (mode === 'Add') {
            handleOnChange("IsActive", e);
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            handleOnChange("IsActive", !formValue.IsActive);
        }
        setModalShow(false);
    }
    //#endregion

    //#region API calling function
    const activitycategorylist = async () => {
        const collectioncategorylist = await getAllData("/master/v1/activitycategorylist");
        if (collectioncategorylist?.status) {
            collectioncategorylist?.data?.map((obj) => {
                obj.label = obj?.collectionName;
                obj.value = obj?.collectionId;

                obj.categoryList?.map((category) => {
                    category.label = category?.categoryName;
                    category.value = category?.categoryId;
                    return category;
                })

                return obj;
            })
            setCollectionList(collectioncategorylist?.data);
        }
        else {
            setCollectionList([]);
        }
    }

    const getallactivitymasterlist = async () => {
        const allactivitymasterlist = await getAllData("/master/v1/getallactivitymasterlist");
        if (allactivitymasterlist?.status) {
            allactivitymasterlist?.data?.map((obj, index) => {
                obj.SrNo = index + 1;
                obj.IsActiveFormat = obj?.IsActive ? "Active" : "InActive";
                obj.CreatedDateFormat = formatDate(obj?.CreatedDate);
                return obj;
            })
            setActivityNameList(allactivitymasterlist?.data ? allactivitymasterlist?.data : []);
            setFilterList(allactivitymasterlist?.data ? allactivitymasterlist?.data : []);
        }
        else {
            setActivityNameList([]);
            setFilterList([]);
        }

    }

    const getcountrystatecity = async () => {
        const countrystatecity = await getAllData(`/master/v1/getcountrystatecity`);
        if (countrystatecity?.status) {
            setCountryCity({
                stateData: countrystatecity?.data?.stateData?.filter(val => val.CountryId === 1)?.map((city) => (
                    { label: city?.StateNAme, value: city?.StateId }
                )),
                cityData: countrystatecity?.data?.cityData?.filter(val => val.CountryId === 1)?.map((city) => (
                    { label: city?.City, value: city?.LocationId, CountryId: city?.CountryId, StateId: city?.StateId }
                )),
            });
        }
    }

    const cityList = useMemo(() => {
        return countryCity?.cityData?.filter((obj) => formValue?.StateIds?.includes(obj.StateId)) ?? [];
    }, [countryCity, formValue?.StateIds])

    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                Promise.allSettled([
                    getallactivitymasterlist(),
                    activitycategorylist(),
                    getcountrystatecity()
                ])
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        fetchData();
    }, [])
    //#endregion

    //#region columns
    const columns = [
        {
            name: 'Sr. No',
            key: 'SrNo',
            sortable: true,
            reorder: true,
            selector: (data) => data?.SrNo,
        },
        {
            name: 'Collection name',
            key: 'CollectionName',
            sortable: true,
            reorder: true,
            selector: (data) => data?.CollectionName,
        },
        {
            name: 'Category name',
            key: 'CategoryNames',
            sortable: true,
            reorder: true,
            selector: (data) => data?.CategoryNames,
            format: (data) => data?.CategoryNames,
        },
        {
            name: 'Activity Name',
            key: 'ActivityName',
            sortable: true,
            reorder: true,
            selector: (data) => data?.ActivityName,
        },
        {
            name: 'State Name',
            key: 'StateNames',
            sortable: true,
            reorder: true,
            selector: (data) => data?.StateNames,
        },
        {
            name: 'City Name',
            key: 'CityNames',
            sortable: true,
            reorder: true,
            selector: (data) => data?.CityNames,
        },
        {
            name: 'Active',
            key: 'IsActiveFormat',
            sortable: true,
            reorder: true,
            selector: (data) => data?.IsActiveFormat,
        },
        {
            name: 'Created Date',
            key: 'CreatedDateFormat',
            sortable: true,
            reorder: true,
            selector: (data) => new Date(data?.CreatedDate),
            format: (data) => data?.CreatedDateFormat,
        },
        {
            name: 'Edit',
            selector: (data) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit} ><i className="fa fa-edit" onClick={() => handleEditViewMode("Edit", data?.ActivityId)}></i></button>
        },
        {
            name: 'View',
            selector: (data) => <i className="fa fa-eye cursor_pointer" onClick={() => handleEditViewMode("View", data?.ActivityId)}></i>
        }
    ]
    //#endregion

    //#region retrieve data on edit and view function
    const handleEditViewMode = (type, id) => {
        setFormErrors(null);
        setMode(type);
        setSearchDisable(true);
        setEditDisabled(type === "Edit" ? true : false);
        setDisabled(type === "View" ? true : false);

        const retrieveData = ActivityNameList?.find((obj) => obj?.ActivityId === id);

        setFormValue((prev) => ({
            ...prev,
            ActivityId: retrieveData?.ActivityId ? retrieveData?.ActivityId : 0,
            CollectionId: retrieveData?.CollectionId ? retrieveData?.CollectionId : 0,
            StateIds: retrieveData?.StateIds ? JSON.parse(retrieveData?.StateIds) : [],
            LocationIds: retrieveData?.LocationIds ? JSON.parse(retrieveData?.LocationIds) : [],
            CategoryIds: retrieveData?.CategoryIds ? JSON.parse(retrieveData?.CategoryIds) : [],
            ActivityName: retrieveData?.ActivityName ? retrieveData?.ActivityName : "",
            ImageName: retrieveData?.ImageName ? retrieveData?.ImageName : "",
            ImagePath: retrieveData?.ImagePath ? retrieveData?.ImagePath : "",
            IsActive: retrieveData?.IsActive ? retrieveData?.IsActive : false,
        }))
        setDeleteImage(retrieveData?.ImagePath ? `${CommonFileURLWithFolder}${retrieveData?.ImagePath}` : "")
    }
    //#endregion

    //#region validation
    const validateData = () => {
        let status = true;
        let error = {};

        if (formValue.CollectionId <= 0 || !formValue.CollectionId) {
            error.CollectionId = "Kindly Select The Collection Name.";
            status = false;
        }
        if (formValue.CategoryIds?.length <= 0) {
            error.CategoryIds = "Kindly Select The Category Name.";
            status = false;
        }
        if (formValue.StateIds?.length <= 0) {
            error.StateIds = "Kindly Select State name.";
            status = false;
        }
        if (formValue.StateIds?.length > 0 && formValue.LocationIds?.length <= 0) {
            error.LocationIds = "Kindly select city name.";
            status = false;
        }
        if (!formValue.ActivityName || formValue.ActivityName?.trim()?.length <= 0) {
            error.ActivityName = "Kindly Enter Activity Name.";
            status = false;
        }

        const isDuplicateItem = filterList?.filter((obj) =>
            obj?.ActivityId !== formValue?.ActivityId &&
            obj?.CollectionId === formValue?.CollectionId &&
            areArraysEqualIgnoreOrder(JSON.parse(obj.CategoryIds), formValue.CategoryIds) &&
            obj?.ActivityName?.trim() === formValue.ActivityName?.trim()
        );

        if (isDuplicateItem?.length > 0) {
            error.ActivityName = "Activity name already exists.";
            status = false;
        }

        setFormErrors(error);

        if (Object.keys(error)?.length > 0) {
            const eleId = Object.keys(error)?.[0]
            document.getElementById(eleId)?.focus();
        }

        return status;
    }
    //#endregion

    //#region Add/Update function
    const handleSave = async () => {
        if (validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let isDeleted = { value: true };
                let isUploaded = { value: true };
                if (!formValue?.ImagePath) {
                    isDeleted = deleteImage !== "" ? await Promise.allSettled([await ImageDelete(deleteImage)]) : { value: true }
                }
                else {
                    if (formValue?.needToUpload) {
                        [isDeleted, isUploaded] = await Promise.allSettled([
                            deleteImage !== "" ? await ImageDelete(deleteImage) : true,
                            await ImageUpload(formValue?.Path, formValue?.ImageName, formValue?.File)
                        ])
                    }
                }

                if (isUploaded?.value) {
                    const user = GetLocalStorage();
                    const upsertactivity = await postUsersData('/master/v1/upsertactivity', { ...formValue, UserId: user?.userMasterID });
                    if (upsertactivity?.status) {
                        handleClear();
                        getallactivitymasterlist();
                        dispatch({ type: 'ALERTING', message: upsertactivity?.message })
                    }
                    else {
                        dispatch({ type: 'ALERTING', message: upsertactivity?.message })
                    }
                }
                else {
                    console.error('Error:- Error while upload the file')
                    return;
                }
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
    }
    //#endregion

    //#region clear function
    const handleClear = () => {
        setFormErrors(null);
        setMode("Add");
        setDisabled(false);
        setSearchDisable(false);

        setFormValue({
            ActivityId: 0,
            CollectionId: 0,
            StateIds: [],
            LocationIds: [],
            CategoryIds: [],
            ActivityName: "",
            ImageName: "",
            ImagePath: "",
            IsActive: false,
            UserId: 0
        });
        document.getElementById("UploadImage").value = "";
    }
    //#endregion

    //#region pdf export function
    const PDFExport = () => {
        const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const rows = ActivityNameList?.map((obj) => keys?.map((key) => obj[key]))
        generatePDF(pdfColumns, rows, "Activity", "Activity", "l")
    }
    //#endregion

    //#region excel export function
    const ExcelExport = () => {
        const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        ExportExcel(dispalyname, fields, ActivityNameList, "Activity", "Activity.xls");
    }
    //#endregion


    return (
        <div className="container-fluid form_border py-5 my-3">
            <div className="row">

                <CustomColumn labelText='Select Collection' labelId='CollectionId' isRequired >
                    <Select
                        className="dropdown select_dropdown"
                        inputId='CollectionId'
                        options={collectionList}
                        value={collectionList?.filter((prev) => prev?.value === formValue?.CollectionId)}
                        onChange={(e) => handleOnChange('CollectionId', e ? e?.value : 0)}
                        isSearchable
                        isDisabled={disabled ? true : false}
                        placeholder='Select Collection'
                    />
                    {formErrors?.CollectionId && <div className="text-danger text-start fs_14">{formErrors?.CollectionId}</div>}
                </CustomColumn>

                <CustomColumn labelText='Select Category' labelId='CategoryIds' isRequired >
                    <Select
                        className="dropdown select_dropdown"
                        inputId='CategoryIds'
                        options={categoryList}
                        value={categoryList?.filter((prev) => formValue?.CategoryIds?.includes(prev.value))}
                        onChange={(e) => handleOnChange('CategoryIds', e ? e?.map((obj) => obj.value) : [])}
                        isMulti
                        isSearchable
                        isDisabled={disabled}
                        placeholder='Select Category'
                        components={{
                            Option: SelectDropDownCheckboxInputOption
                        }}
                        hideSelectedOptions={false}
                        closeMenuOnSelect={false}
                    />
                    {formErrors?.CategoryIds && <div className="text-danger text-start fs_14">{formErrors?.CategoryIds}</div>}
                </CustomColumn>

                <CustomColumn labelText='Activity Name' labelId='ActivityName' isRequired >
                    <input
                        type="text"
                        className='form-control'
                        name="ActivityName"
                        id="ActivityName"
                        value={formValue.ActivityName}
                        onChange={(e) =>
                            e.target.value?.length <= 100 &&
                            handleOnChange(e.target.name, onlyAlphabets(e.target.value))
                        }
                        maxLength={100}
                        disabled={disabled ? true : false}
                        placeholder='Activity Name'
                    />
                    {formErrors?.ActivityName && <div className="text-danger text-start fs_14">{formErrors?.ActivityName}</div>}
                </CustomColumn>

                <CustomColumn colNum={6} labelText='Upload Image' labelId='UploadImage'>
                    <div className="input-group">
                        <input
                            type="file"
                            className='form-control btn_add'
                            id="UploadImage"
                            accept=".png"
                            onChange={handleUploadImage}
                            disabled={disabled ? true : false}
                        />
                        <label
                            htmlFor="UploadImage"
                            className='input-group-text'
                        >
                            Browse
                        </label>
                    </div>
                    {formValue.ImageName && <div className='text-start fs_14'>{formValue.ImageName}</div>}
                    {formErrors?.ImageName && <div className="text-danger text-start fs_14">{formErrors?.ImageName}</div>}
                </CustomColumn>

                <CustomColumn labelText='Select State' labelId='StateId' isRequired >
                    <Select
                        className="dropdown select_dropdown"
                        inputId='StateId'
                        isMulti
                        options={countryCity?.stateData}
                        value={countryCity?.stateData?.filter((prev) => formValue?.StateIds?.includes(prev?.value))}
                        onChange={(e) => handleOnChange('StateIds', e ? e?.map((obj) => obj.value) : [])}
                        isSearchable
                        isDisabled={disabled ? true : false}
                        placeholder='Select State'
                    />
                    {formErrors?.StateIds && <div className="text-danger text-start fs_14">{formErrors?.StateIds}</div>}
                </CustomColumn>

                <CustomColumn labelText='Select City' labelId='LocationId' isRequired={formValue.StateIds?.length > 0} >
                    <Select
                        className="dropdown select_dropdown"
                        inputId='LocationId'
                        isMulti
                        options={cityList}
                        value={cityList?.filter((prev) => formValue?.LocationIds?.includes(prev?.value))}
                        onChange={(e) => handleOnChange('LocationIds', e ? e?.map((obj) => obj.value) : [])}
                        isSearchable
                        isDisabled={disabled || formValue?.StateIds?.length <= 0}
                        placeholder='Select City'
                    />
                    {formErrors?.LocationIds && <div className="text-danger text-start fs_14">{formErrors?.LocationIds}</div>}
                </CustomColumn>


                <CustomColumn colNum={6} labelText='Active' labelId='Active' classChildren={'align-content-center'}>
                    <Switch
                        onChange={handleisActive}
                        checked={formValue.IsActive}
                        className="react-switch"
                        disabled={disabled ? true : false}
                    />
                    <ConfirmationModal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                        noconfirm={() => handleConfirmation(false)}
                        yesconfirm={() => handleConfirmation(true)}
                    />
                </CustomColumn>
            </div>

            {formValue?.ImagePath?.length > 0 && (
                <div className='row my-3'>
                    <div className="col-lg-2 col-md-3 col-6 mx-auto mt-2" >
                        <img
                            src={formValue.needToUpload ? URL.createObjectURL(formValue?.File) : `${CommonFileURLWithFolder}${formValue.ImagePath}`}
                            className="img-fluid w-100"
                            alt="uploaded"
                            style={{ objectPosition: "right top" }}
                        />
                    </div>
                </div>
            )}

            <div className="d-flex justify-content-center mb-4">
                <button type="button" className="btn btn-primary mx-1" disabled={disabled || editDisabled || (mode === "Add" && !useradd)} onClick={handleSave}> {mode === "Edit" ? "Update" : "Add"} </button>
                <button type="button" className="btn btn-primary mx-1" onClick={handleClear}>Clear</button>
            </div>


            <CommonFilter
                columns={columns}
                filterList={filterList}
                searchDisabled={searchDisabled}
                getdata={getallactivitymasterlist}
                setlistdata={setActivityNameList}
                searchvalue={searchvalue}
                setSearchValue={setSearchValue}
                searchby={searchby}
                setSerachBy={setSerachBy}
            />
            <CustomTable
                className="last_two_column_freeze freezEditViewAtLast"
                columns={columns}
                data={ActivityNameList}
                disabled={!userexport}
                PdfExport={() => PDFExport()}
                ExportToExcel={() => ExcelExport()}
            />

        </div>
    )
}

export default ActivityTab